import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { fleetEnvironment } from '../fleet-environment';
import { fleetMessageSchema } from '../schemas/fleet-message.schema';

/**
 * Assigns Avoid Favor Sets to a given Vehicle Group
 * @param vehicleGroupId ID of the Vehicle Group being assigned to
 * @param assignmentAvoidFavorSetIds IDs of Avoid Favor Sets being assigned
 * @param unassignmentAvoidFavorSetIds IDs of Avoid Favor Sets being unassigned
 * @returns Array of IDs
 */
export function postVehicleGroupsIdAvoidFavorSetsCombinedAssignment(
  this: unknown,
  vehicleGroupId: number,
  assignmentAvoidFavorSetIds: number[],
  unassignmentAvoidFavorSetIds: number[]
) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(
        fleetEnvironment
          .resolve(this)
          .vehicleGroupsAvoidFavorSetsCombinedAssignmentUrl(vehicleGroupId),
        {
          method: 'POST',
          headers: {
            ...requiredHeaders,
            ...jwtAuthHeaders,
          },
          body: JSON.stringify({
            assignmentAvoidFavorSetIds,
            unassignmentAvoidFavorSetIds,
          }),
        }
      )
    )
  ).pipe(
    selectData(
      fleetMessageSchema.extend({
        data: z.object({
          assigned: z.array(z.number()),
          unassigned: z.array(z.number()),
        }),
      })
    )
  );
}
